/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Card,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    MenuItem,
    TextField,
    Toolbar,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import React from 'react';
import { IFormularioFlujosEtapasVistaProps } from '../interfaces';

const FormularioFlujosEtapasVista: React.FunctionComponent<IFormularioFlujosEtapasVistaProps> = ({
    accionCrearEditar,
    alCambiarValor,
    alCambiarValorAutoComplete,
    cerrarFormulario,
    estadoFormulario,
    entidadesFlujosEtapas,
    esMovil,
    flujosEtapas,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario} fullWidth maxWidth={esMovil ? 'lg' : 'sm'}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'flujosEtapas.agregarFlujosEtapas'
                                : 'flujosEtapas.modificarFlujosEtapas'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Card>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Autocomplete
                                getOptionLabel={({ FlujoDescripcion }) => FlujoDescripcion}
                                onChange={(_: any, flujo: any) => alCambiarValorAutoComplete(flujo, 'Flujo')}
                                options={entidadesFlujosEtapas.flujoss}
                                noOptionsText={<Texto id="label.sinRegistros" />}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label={<Texto id="flujosEtapas.flujoId" display="inline" />}
                                    />
                                )}
                                value={flujosEtapas.Flujo}
                                id={`CampoflujoId-${flujosEtapas.Flujo}`}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                getOptionLabel={({ EtapaDescripcion }) => EtapaDescripcion}
                                onChange={(_: any, etapa: any) => alCambiarValorAutoComplete(etapa, 'EtapaActual')}
                                options={entidadesFlujosEtapas.etapass}
                                noOptionsText={<Texto id="label.sinRegistros" />}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label={<Texto id="flujosEtapas.etapaActual" display="inline" />}
                                    />
                                )}
                                value={flujosEtapas.EtapaActual}
                                id={`CampoEtapaActual-${flujosEtapas.EtapaActual}`}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                getOptionLabel={({ EtapaDescripcion }) => EtapaDescripcion}
                                onChange={(_: any, etapa: any) => alCambiarValorAutoComplete(etapa, 'EtapaSiguiente')}
                                options={entidadesFlujosEtapas.etapass}
                                noOptionsText={<Texto id="label.sinRegistros" />}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        label={<Texto id="flujosEtapas.etapaSiguiente" display="inline" />}
                                    />
                                )}
                                value={flujosEtapas.EtapaSiguiente}
                                id={`CampoEtapaSiguiente-${flujosEtapas.EtapaSiguiente}`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={Boolean(flujosEtapas.Entrada)}
                                        onChange={alCambiarValor}
                                    />
                                }
                                label={<Texto id="flujosEtapas.entrada" display="inline" />}
                                name="Entrada"
                                id={`Entrada-${flujosEtapas.Entrada}`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={Boolean(flujosEtapas.Salida)}
                                        onChange={alCambiarValor}
                                    />
                                }
                                label={<Texto id="flujosEtapas.salida" display="inline" />}
                                name="Salida"
                                id={`Salida-${flujosEtapas.Salida}`}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={Boolean(flujosEtapas.Estado)}
                                        onChange={alCambiarValor}
                                    />
                                }
                                label={<Texto id="flujosEtapas.estado" display="inline" />}
                                name="Estado"
                                id={`CampoEstado-${flujosEtapas.Estado}`}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button onClick={cerrarFormulario} color="secondary" variant="contained" id="boton-cancelarFlujosEtapas">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={accionCrearEditar} color="primary" variant="contained" id="boton-editarFlujosEtapas">
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioFlujosEtapasVista;
